import { createSelector } from '@reduxjs/toolkit';

import { FormStepId } from 'shared/config/formStepId';

import { selectIsFilledByEsia } from 'entities/creditForm';
import { userEsiaIsErrorSelector, userHasEsiaSelector, userEsiaStartStepSelector } from 'entities/user';
import { isWLSelector, whiteLabelAffIdSelector } from 'entities/whiteLabels';

import { PARTNERS_IDS_WITH_ESIA_FEATURE } from 'features/AuthenticationEsia/AuthenticationEsia.config';
import { EsiaTextsConfig } from 'features/AuthenticationEsia/AuthenticationEsia.texts';

export const EsiaWlConfigSelector = (step?: string) =>
  createSelector(whiteLabelAffIdSelector, (affId) => {
    if (affId) {
      return EsiaTextsConfig[affId] || EsiaTextsConfig.default;
    }

    if (step) {
      return EsiaTextsConfig[step as ValuesOf<typeof FormStepId>] || EsiaTextsConfig.default;
    }

    return EsiaTextsConfig.default;
  });

export const showLoginByEsiaSelector = (step?: string) =>
  createSelector(
    userHasEsiaSelector,
    userEsiaIsErrorSelector,
    isWLSelector,
    whiteLabelAffIdSelector,
    EsiaWlConfigSelector(step),
    (isHasEsia, isEsiaError, isWl, affId, textConfig) => {
      const isPartnerHasEsiaFeature = !!affId && PARTNERS_IDS_WITH_ESIA_FEATURE.includes(affId);

      if (isEsiaError) {
        return {
          isEsiaAvailable: false,
          isWl,
          ...EsiaTextsConfig.error,
        };
      }

      return {
        isEsiaAvailable: !isHasEsia && (!isWl || (isWl && isPartnerHasEsiaFeature)),
        isWl,
        ...textConfig,
      };
    },
  );

export const showEsiaErrorSelector = (step: string) =>
  createSelector(
    userEsiaIsErrorSelector,
    userEsiaStartStepSelector,
    (isEsiaError, activatedStep) => isEsiaError && activatedStep === step,
  );

export const shouldUpdateEsiaSelector = createSelector(
  selectIsFilledByEsia,
  (isFormFilledByEsia): Record<string, boolean> => ({
    [FormStepId.PassportInfo]: !isFormFilledByEsia,
  }),
);
